import { useTranslation } from "react-i18next";

import { MarkdownContent } from "@/components/MarkdownContent";
import { WFPButton } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { TermsOfUseDialogProps } from "./types";

export function TermsOfUseDialog({ open, isBusy, markdown, onAccept }: TermsOfUseDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <DialogContent
        showCloseButton={false}
        onInteractOutside={event => event.preventDefault()}
        onEscapeKeyDown={event => event.preventDefault()}
        className="sm:max-w-2xl"
      >
        <DialogHeader>
          <DialogTitle>{t("termsAndConditions.title")}</DialogTitle>
          <DialogDescription>{t("termsAndConditions.text")}</DialogDescription>
        </DialogHeader>
        <MarkdownContent markdown={markdown} className="max-h-[60vh] overflow-y-auto" />
        <DialogFooter>
          <WFPButton onClick={onAccept} disabled={isBusy}>
            {isBusy ? t("termsAndConditions.waiting") : t("termsAndConditions.accept")}
          </WFPButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
